import ExpensePage from "@/pages/ExpensePage";
export default function SpeseGuesthouse() {
  return (
    <ExpensePage
      category="guesthouse"
      title="Spese Guesthouse"
      subtitle="Bollette, lavori, ristorante e spese generali"
      hasSub
    />
  );
}
